<template>
  <div>
    <!-- Header -->
    <div class="header bg-gdt py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <b-img
                src="img/theme/gold_dragon_logo.png"
                class="custom-logo-login"
                fluid />
              <h1 class="text-white">ยินดีต้อนรับ</h1>
              <p class="text-lead text-white">มังกรทองขนส่ง</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <!-- <div class="separator separator-bottom separator-skew zindex-100"> -->
      <!-- <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient
              id="goldGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%">
              <stop offset="0%" style="stop-color: #ffd700; stop-opacity: 1" />
              <stop
                offset="100%"
                style="stop-color: #ffaa00; stop-opacity: 1" />
            </linearGradient>
          </defs>

          <polygon
            fill="url(#goldGradient)"
            points="2560 0 2560 100 0 100"></polygon>
        </svg> -->
      <!-- </div> -->
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="border-0 mb-0 shadow">
            <b-card-header class="bg-transparent">
              <div class="text-muted text-center mt-2">
                <strong>เข้าสู่ระบบ</strong>
              </div>
            </b-card-header>
            <b-card-body class="px-lg-5 py-lg-5">
              <!-- <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              > -->
              <b-form role="form" @submit.prevent="onSubmit">
                <base-input
                  :input-attrs="{ autocomplete: 'off' }"
                  alternative
                  class="mb-3"
                  name="Email"
                  prepend-icon="ni ni-email-83"
                  placeholder="Email"
                  v-model="model.email">
                </base-input>

                <base-input
                  :input-attrs="{ autocomplete: 'off' }"
                  alternative
                  class="mb-3"
                  name="Password"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Password"
                  v-model="model.password">
                </base-input>
                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >เข้าสู่ระบบ</base-button
                  >
                </div>
              </b-form>
              <!-- </validation-observer> -->
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import empoyeeServices from "@/api/empoyee.service.js";
import VueJwtDecode from "vue-jwt-decode";
import { modalError } from "@/util/alert.js";

export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
      },
    };
  },
  mounted() {
    localStorage.removeItem("token");
  },
  methods: {
    async onSubmit() {
      let user = null;
      try {
        const res = await empoyeeServices.login({
          email: this.model.email,
          password: this.model.password,
        });
        user = res.data.data;
        if (!user.token) {
          modalError(this.$bvModal, "อีเมล์ หรือ รหัสผ่าน ไม่ถูกต้อง");
          return;
        }
      } catch (err) {
        console.log(err);
        modalError(this.$bvModal, "กรุณากรอกข้อมูลให้ถูกต้อง");
        return;
      }
      const token = user.token;
      const tokenDecode = VueJwtDecode.decode(token);
      localStorage.setItem("token", token);
      if (tokenDecode.role == "driver") {
        this.$router.push({ name: "home" });
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>
